//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "APACHE2",
  data() {
    return {
      defaultJson: {
        "PaO₂": "PaO₂",
        "Heart Rate": "心率",
        "Chronic Organ Insufficiency and/or Immunosuppression":
          "慢性器官功能不全和/或免疫抑制",
        "< 50%": "< 50%",
        "Lab Values": "实验室指标",
        "Aa Gradient": "肺泡-动脉氧分压差",
        "Serum Creatinine": "血肌酐",
        MAP: "平均动脉压",
        "HCO₃": "HCO₃",
        GCS: "GCS",
        "No Surgery": "无需手术",
        "White Cell Count": "白细胞计数",
        "Acute Renal Failure": "急性肾功能衰竭",
        "Respiratory Rate": "呼吸频率",
        "Serum K": "血钾（K）",
        "Serum Na": "血钠（Na）",
        "FiO₂": "FiO₂",
        "Arterial pH": "动脉血 pH",
        Elective: "择期手术",
        Hematocrit: "红细胞比容",
        "Patient Facts": "患者情况",
        "Pred. Death Rate": "预测死亡率",
        Age: "年龄",
        Emergency: "急诊手术",
        Temperature: "体温",
        "≥ 50%": "≥ 50%",
        "ABG available": "是否行动脉血气",
        pH: "pH",
      },
      form: {
        age: "",
        temp: "",
        rr: "",
        hr: "",
        map: "",
        gcs: "",
        chronicDisease: "0",
        sx: "",

        hct: "",
        wbc: "",
        na: "",
        k: "",
        creat: "",
        arf: "0",
        abg: "0",
        hco3: "",
        ph: "",
        fio2: "",
        po2: "",
        aagradient: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "1", name: "无需手术" },
        { value: "2", name: "择期手术" },
        { value: "5", name: "急诊手术" },
      ],
      dataList2: [
        { value: "0", name: "<50%" },
        { value: "1", name: "≥50%" },
      ],
      logit: "...",
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      console.log(self.form);
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      if (form.chronicDisease == "0") {
        form.sx = "0";
      }
      if (form.abg == "0") {
        form.ph = "0";
      } else if (form.abg == "1") {
        form.hco3 = "0";
      }
      if (form.fio2 == "0") {
        form.aagradient = "0";
      } else if (form.fio2 == "1") {
        form.po2 = "0";
      }
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }

      if (form.sx == 1) {
        form.sx = 5;
      }
      if (!flag) {
        self.hasScore = false;
        self.logit = "...";
        return "...";
      } else {
        console.log(form);
        let result =
          (form.age < 45
            ? 0
            : form.age <= 54
            ? 2
            : form.age <= 64
            ? 3
            : form.age <= 74
            ? 5
            : 6) +
          (form.temp < 30
            ? 4
            : form.temp < 32
            ? 3
            : form.temp < 34
            ? 2
            : form.temp < 36
            ? 1
            : form.temp < 38.5
            ? 0
            : form.temp < 39
            ? 1
            : form.temp < 41
            ? 3
            : 4) +
          (form.map < 50
            ? 4
            : form.map < 70
            ? 2
            : form.map < 110
            ? 0
            : form.map < 130
            ? 2
            : form.map < 160
            ? 3
            : 4) +
          (form.hr < 40
            ? 4
            : form.hr < 55
            ? 3
            : form.hr < 70
            ? 2
            : form.hr < 110
            ? 0
            : form.hr < 140
            ? 2
            : form.hr < 180
            ? 3
            : 4) +
          (form.rr < 6
            ? 4
            : form.rr < 10
            ? 2
            : form.rr < 12
            ? 1
            : form.rr < 25
            ? 0
            : form.rr < 35
            ? 1
            : form.rr < 50
            ? 3
            : 4) +
          (form.na < 111
            ? 4
            : form.na < 120
            ? 3
            : form.na < 130
            ? 2
            : form.na < 150
            ? 0
            : form.na < 155
            ? 1
            : form.na < 160
            ? 2
            : form.na < 180
            ? 3
            : 4) +
          (form.k < 2.5
            ? 4
            : form.k < 3
            ? 2
            : form.k < 3.5
            ? 1
            : form.k < 5.5
            ? 0
            : form.k < 6
            ? 1
            : form.k < 7
            ? 3
            : 4) +
          (form.hct < 20
            ? 4
            : form.hct < 30
            ? 2
            : form.hct < 46
            ? 0
            : form.hct < 50
            ? 1
            : form.hct < 60
            ? 2
            : 4) +
          (form.wbc < 1
            ? 4
            : form.wbc < 3
            ? 2
            : form.wbc < 15
            ? 0
            : form.wbc < 20
            ? 1
            : form.wbc < 40
            ? 2
            : 4) +
          (15 - form.gcs) +
          (form.abg
            ? form.ph < 7.15
              ? 4
              : form.ph < 7.25
              ? 3
              : form.ph < 7.33
              ? 2
              : form.ph < 7.5
              ? 0
              : form.ph < 7.6
              ? 1
              : form.ph < 7.7
              ? 3
              : 4
            : form.hco3 < 15
            ? 4
            : form.hco3 < 18
            ? 3
            : form.hco3 < 22
            ? 2
            : form.hco3 < 32
            ? 0
            : form.hco3 < 41
            ? 1
            : form.hco3 < 52
            ? 3
            : 4) +
          (form.fio2
            ? form.aagradient < 200
              ? 0
              : form.aagradient < 350
              ? 2
              : form.aagradient < 500
              ? 3
              : 4
            : form.po2 < 55
            ? 4
            : form.po2 < 61
            ? 3
            : form.po2 < 71
            ? 1
            : 0) +
          (form.arf
            ? form.creat < 54
              ? 4
              : form.creat < 130
              ? 0
              : form.creat < 170
              ? 4
              : form.creat < 305
              ? 6
              : 8
            : form.creat < 54
            ? 2
            : form.creat < 130
            ? 0
            : form.creat < 170
            ? 2
            : form.creat < 305
            ? 3
            : 4) +
          (form.chronicDisease ? form.sx : 0);

        let baseLogit = -3.517 + result * 0.146;
        self.logit = (
          100 *
          (Math.pow(Math.E, baseLogit) / (1 + Math.pow(Math.E, baseLogit)))
        ).toFixed(1);

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/APACHE2.vue